import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var bgimg1 = require('./../../images/background/bg-5.png');
var defaultRightImage = require('./../../images/background/bg-2.jpg');
var bgimg3 = require('./../../images/background/cross-line2.png');
var defaultCard1 = require('./../../images/pic1.jpg');
var defaultCard2 = require('./../../images/pic2.jpg');
var defaultCard3 = require('./../../images/pic3.jpg');

const fallbackItems = [
    { number: '01', title: 'Çelik Kapı Üretimi', image: defaultCard1 },
    { number: '02', title: 'Özel Ölçü Tasarım', image: defaultCard2 },
    { number: '03', title: 'Montaj ve Servis', image: defaultCard3 }
];

class WhatWeDo1 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const section = t?.pages?.about?.whatWeDo || {};
        const items = Array.isArray(section.items) ? section.items : [];
        const mediaCards = getByPath(content, 'media.pages.aboutWhatWeDoCards', []);
        const rightImage = resolveMediaSrc(getByPath(content, 'media.pages.aboutWhatWeDoRightImage', ''), defaultRightImage);

        return (
            <>
                <div className="section-full home-what-we-do-section mobile-page-padding bg-white p-t80 p-b30 bg-repeat overflow-hide" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container right-half-bg-image-outer">
                        <div className="right-half-bg-image bg-parallax bg-fixed bg-top-right" data-stellar-background-ratio={0} style={{ backgroundImage: 'url(' + rightImage + ')' }} />
                        <div className="section-head">
                            <div className="sx-separator-outer separator-left">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg3 + ')' }}>
                                    <h3 className="sep-line-one">{section.title || 'Neler Yapıyoruz?'}</h3>
                                </div>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="row number-block-one-outer justify-content-center">
                                {fallbackItems.map((fallbackItem, index) => {
                                    const item = items[index] || {};
                                    const mediaItem = (Array.isArray(mediaCards) ? mediaCards[index] : null) || {};
                                    const image = resolveMediaSrc(mediaItem.imageUrl, fallbackItem.image);

                                    return (
                                        <div className="col-lg-4 col-md-6 col-sm-6 m-b30" key={`home-what-we-do-${index}`}>
                                            <div className="number-block-one animate-in-to-top">
                                                <img src={image} alt="" />
                                                <div className="figcaption bg-white text-center p-a20">
                                                    <h4 className="m-a0">{item.title || fallbackItem.title}</h4>
                                                </div>
                                                <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                                                    <span>{item.number || fallbackItem.number}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default WhatWeDo1;
